module.exports = "<div class=\"tooltip\">\n\n\t<strong>{{title}}<br/></strong>\n\tCases: <strong>{{cases}}</strong>\n\n</div>\n"